<key-layout-view [page]="path" [show]="true" [scroll]="false" [header]="!(media.isDesktop | async) && mobileHeader">
    @for (tab of tabs; track tab) {
        <div class="flex-1" [class.hidden]="active !== tab.id">
            @if (tab.activated) {
                <iframe width="100%" height="100%" frameBorder="0" [src]="tab.url"> </iframe>
            }
        </div>
    }
</key-layout-view>
